import { Icon } from "@iconify/react";
import React, { useContext } from "react";
import { useLiveCurrentPoints } from "../../../hooks/points";
import { GlobalModalsContext, brand } from "../../../context";

export const PointsSmallWidget = () => {
  const { availablePoints } = useLiveCurrentPoints();
  const { setShowTopUpPointsModal } = useContext(GlobalModalsContext);

  return (
    <div
      className="PointsSmallWidget"
      title={`Available${brand === "travily" ? " Travily" : ""} Points`}
      onClick={() => setShowTopUpPointsModal(true)}>
      <Icon icon="iconoir:coins-swap" className="PointsSmallWidget__icon" />
      <span className="PointsSmallWidget__points">
        {availablePoints.toLocaleString("en-US", {
          maximumFractionDigits: 2,
        })}
      </span>
    </div>
  );
};
